// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__ALWqE","slide-down":"Modal_slide-down__B84s-"};